import { Button, Collapse, FormControl, FormControlLabel, FormLabel, InputLabel, MenuItem, Radio, RadioGroup, Select, Stack } from "@mui/material";
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import type { RootState } from '../../../types/store';
import PlayerInfoForm from '../../../components/player/player-info-form';
import GameCategoryListDisplay from '../../../components/gamecategory/game-category-list-display';
import AppConstants from '../../../constants/app-constants';
import AppActions from '../../../actions/app-actions';
import UIError from '../../../components/ui-error';

export default function CreateStandardGameForm() {
    const [isPlaying, setIsPlaying] = useState(false);
    const [language, setLanguage] = useState(1);
    const [categories, setCategories] = useState([1, 4, 5]);
    const [name, setName] = useState("");

    const navigate = useNavigate(); 
    const create = useSelector((state:RootState) => state.page.create);
    const dispatch = useDispatch();
    const translate = useSelector((state:RootState) => state.ui.language);
    const settings = useSelector((state:RootState) => state.settings);
    
    useEffect(() => {
        dispatch(AppActions.CreateLobbyReset({}));
    }, []);
    
    useEffect(() => {
        if(create.success)
        {
            navigate("/lobby/"+create.code);
            dispatch(AppActions.CreateLobbyReset({}));
        }
    }, [create, navigate]);
    
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsPlaying(event.target.value !== "host");
    };

    const onChangeLanguage = (value:number) => {
        setLanguage(value);
    };
    
    function onChangeName(name:string)
    {
        setName(name);
    }
    
    function onChangeCategory(id:number)
    {
        setCategories(prevCategories => {
            // Check if the id already exists in the array
            if (prevCategories.includes(id)) {
                // If it exists, remove it
                return prevCategories.filter(categoryId => categoryId !== id);
            } else {
                // If it doesn't exist, add it
                return [...prevCategories, id];
            }
        });
    }
    
    function onCreate() {
        dispatch(AppActions.CreateLobby({ mode: AppConstants.GAMEMODE_STANDARD, playing: isPlaying, nickname: name, categories: categories, language: language }));
    }
    
    return (
        <Stack gap={3} sx={{ width: "100%" }}>
            <FormControl>
                <FormLabel color="success">{translate.create.deviceFor}</FormLabel>
                <RadioGroup defaultValue="host" name="radio-buttons-group" row onChange={handleChange}>
                    <FormControlLabel value="host" control={<Radio color="success" />} label={translate.create.hosting} />
                    <FormControlLabel value="play" control={<Radio color="success" />} label={translate.create.playing} />
                </RadioGroup>
            </FormControl>
            <Collapse in={isPlaying} unmountOnExit>
                <PlayerInfoForm onChangeName={onChangeName} />
            </Collapse>
            <FormControl fullWidth>
                <InputLabel>{translate.create.questionsLanguage}</InputLabel>
                <Select value={language.toString()} label={translate.create.questionsLanguage} defaultValue="English"
                        onChange={(event) => { onChangeLanguage(parseInt(event.target.value))}} >
                    {settings.languages.map((v, i) => {
                        return <MenuItem key={i} value={v.id}>{v.language}</MenuItem>;
                    })}
                </Select>
            </FormControl>
            
            <GameCategoryListDisplay gameMode={AppConstants.GAMEMODE_STANDARD} onChange={onChangeCategory} selectedCategories={categories} />
            
            <UIError message={create.error} />
            <Button variant="contained" disabled={create.isLoading} sx={{ marginBottom: 2 }} onClick={onCreate} >
                {translate.create.createLobby}
            </Button>
        </Stack>
    );
}
